import React from "react";
import Markdown from "markdown-to-jsx";
import { overrides as baseOverrides } from "./MarkdownConfig";
import Tooltip from "@shared/components/Assistant/Tooltip";

export interface InlineBadge {
  n: number;
  project_id?: string | null;
  file_id?: string;
  original_file?: string;
  page_number?: number;
  sheet_name?: string;
  start_row?: number;
  hoverText: string;
  kind?: "document" | "tabular" | "web";
  url?: string;
  title?: string;
}

interface MessageProcessorProps {
  message?: string;
  citations: InlineBadge[];
  setShowDocxModal: (show: boolean) => void;
  setDocxContent: (content: string) => void;
  setShowExcelModal: (show: boolean) => void;
  setExcelData: (data: any[][]) => void;
  showDocxModal: boolean;
  docxContent: string;
  showExcelModal: boolean;
  excelData: any[][];
}

// Marker pattern inserted by Assistant.tsx: " {[CIT:1]}"
const CIT_RE = /\{\[CIT:(\d+)\]\}/g;

export const processMessageWithCitations = ({
  message = "",
  citations = [],
  ...modalProps
}: MessageProcessorProps) => {
  const CIT: React.FC<{ n: string }> = ({ n }) => {
    const num = parseInt(n, 10);
    const badge = citations.find((c) => c.n === num);
    if (!badge) return null;

    return (
      <Tooltip
        content={badge.hoverText}
        projectId={badge.project_id ?? ""}
        original_file={badge.original_file ?? ""}
        sheet_name={badge.sheet_name}
        start_row={badge.start_row}
        page_number={badge.page_number ? String(badge.page_number) : ""}
        file_id={badge.file_id ?? ""}
        {...modalProps}
      >
        <span
          className={
            "text-white hover:cursor-pointer bg-blue-600 text-xs rounded-full text-center px-0 w-[20px] h-[20px] inline-flex justify-center items-center pt-[3px]"
          }
        >
          {num}
        </span>
      </Tooltip>
    );
  };

  // Merge your existing overrides with our inline component
  const overrides = {
    ...baseOverrides,
    CIT: { component: CIT },
  };

  // Replace markers with inline <CIT /> elements (note the leading space)
  const markdownWithCits = message.replace(
    CIT_RE,
    (_m, num) => ` <CIT n="${num}" />`
  );

  return (
    <div className="space-y-2 citationChat">
      <Markdown options={{ overrides }}>{markdownWithCits}</Markdown>
    </div>
  );
};
